export default __webpack_public_path__ + "static/media/businessman.247d363d.svg";